import reqwest from 'reqwest'

const API = {
  member: '//vip.youku.com/member/show_valid_member.jsonp',
  uInfo: '//v.youku.com/api/grade/get_uinfo',
  playLoggradePoint: '//lv.youku.com/api/grade/get_grade_point',
  playLog: '//mstool.youku.com/cms/playlog/get'
}
function getScript (url, op) {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true // for firefox3.6
  if (op.charset) { s.charset = op.charset }
  if (op.crossOrigin) {
    s.crossOrigin = true
  }
  s.src = url
  const h = document.getElementsByTagName('head')[0]
  let done = false
  s.onload = s.onreadystatechange = function () {
    if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
      done = true
      // 防止ie内存泄漏
      s.onload = s.onreadystatechange = null
      if (!op.saveScript) { h.removeChild(s) }
      if (op.callback) { op.callback() }
    }
  }
  h.appendChild(s)
}

const Request = {
  getValidMemeberInfo (callBack) {
    const _params = {
      version: 2
    }
    reqwest({
      url: API.member,
      data: _params,
      type: 'jsonp'
    })
      .then((res) => {
        callBack(res)
      })// 缺失catch处理
  },

  getVipGrade (callBack) {
    reqwest({
      url: API.playLoggradePoint,
      // data: _params,
      type: 'jsonp'
    })
      .then((res) => {
        callBack(res)
      })// 缺失catch处理
  },

  getUInfo (callBack) {
    const _params = {
      from: 'web'
    }
    reqwest({
      url: API.uInfo,
      data: _params,
      type: 'jsonp'
    })
      .then((res) => {
        callBack(res)
      })// 缺失catch处理
  },
  /**
     * 获取vip积分信息
     */
  getPlayLog (callBack) {
    window.tuijsonp6 = (data) => {
      callBack(data)
      window.tuijsonp6 = function () {}
    }
    getScript('//cmstool.youku.com/cms/playlog/get?callback=tuijsonp6', {})
  }
}

export default Request
